






export default
  props:
    page:
      type: Object
  methods:
    move_page: (page) ->
      @$emit('move_page', page)
